const firebaseConfig = {
    apiKey: "AIzaSyDf6GCNz15ziHIelBZPXAcCFHDL4Bz2nsc",
    authDomain: "productronica.firebaseapp.com",
    projectId: "productronica",
    storageBucket: "productronica.appspot.com",
    messagingSenderId: "1034427939000",
    appId: "1:1034427939000:web:fbff8f9395a91a80eddc4d"
};


const vapidKey = "BAU4M9zwtCgBXllkOI63oR7h1fkTmmISl4OiyEQQsCFJgDLZQlyrumdUq0vDdmZa6Z7gSD2r2YJ8tuxGDVds9vI";

export {
    firebaseConfig,
    vapidKey
}
